module.exports = __webpack_public_path__ + "img/Jaiz Bank.1aeb63b5.png";